import Icon from '../components/Icon.vue'

Icon.register({
  cog: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M444.8 291.1L487.4 315.7C492.3 318.5 494.5 324.3 492.9 329.7 481.8 365.3 462.9 397.5 438.2 424.3A12-12 0 0 0 423.3 426.5L380.8 401.9A191.6-191.6 0 0 0 320 437.1V486.2A12-12 0 0 0 310.6 498C275.7 505.8 238.1 506.2 201.4 498 195.9 496.7 192 491.9 192 486.2V437.1A191.6-191.6 0 0 0 131.2 401.9L88.7 426.5A12-12 0 0 0 73.8 424.3C49.1 397.5 30.2 365.3 19.1 329.7 17.5 324.3 19.7 318.5 24.6 315.7L67.2 291.1A193.5-193.5 0 0 0 67.2 220.9L24.6 196.3C19.7 193.5 17.5 187.7 19.1 182.3 30.2 146.7 49.1 114.5 73.8 87.7A12-12 0 0 0 88.7 85.5L131.2 110.1A191.6-191.6 0 0 0 192 74.9V25.8A12-12 0 0 0 201.4 14C236.3 6.2 273.9 5.8 310.6 14 316.1 15.3 320 20.1 320 25.8V74.9A191.6-191.6 0 0 0 380.8 110.1L423.3 85.5A12-12 0 0 0 438.2 87.7C462.9 114.5 481.8 146.7 492.9 182.3 494.5 187.7 492.3 193.5 487.4 196.3L444.8 220.9A193.5-193.5 0 0 0 444.8 291.1zM336 256C336 211.9 300.1 176 256 176S176 211.9 176 256 211.9 336 256 336 336 300.1 336 256z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/cog.js
// module id = 4MOn
// module chunks = 144